import CustomerPanelLayout from "./customer-panel-layout.container";

export default CustomerPanelLayout;
